<template>
  <div class="columnBox">
    <h1 class="study-title">
      <img
        src="../../../assets/img/learningGuidePage/reporttime.png"
        alt=""
      /><span>学习时长</span>
    </h1>
    <div class="columnTitle"><span></span>日统计</div>
    <div id="columnchart"></div>
  </div>
</template>
<script>
import { Column } from '@antv/g2plot';

export default {
  props: {
    weekTimeList: {
      type: Array,
      default: () => { },
    },
  },
  methods: {
    // Y轴最大值比最大数据大20
    getMaxY() {
      // eslint-disable-next-line no-confusing-arrow
      const maxValue = this.weekTimeList.reduce((prev, cur) => prev.dayLearnDuration > cur.dayLearnDuration ? prev : cur);
      return maxValue.dayLearnDuration + 25;
    },
  },
  mounted() {
    const data = this.weekTimeList;
    const columnPlot = new Column('columnchart', {
      data,
      height: 220,
      tooltip: false, // 不显示柱形图的提示数据
      xField: 'statisticsDate',
      yField: 'dayLearnDuration',
      columnStyle: {
        radius: [14, 14, 14, 14],
        fill: 'l(90) 0:#FF7634 1:#FFA376', // 柱形颜色
      },
      label: {
        // 柱形图上的数字
        content: (originData) => {
          const val = `${originData.dayLearnDuration}min`;
          return val;
        },
        style: {
          fill: '#666',
          fontSize: 14,
          fontWeight: 400,
          opacity: 0.6,
        },
      },
      maxColumnWidth: 14,
      yAxis: {
        // 去掉背景横杠
        grid: null,
        max: this.getMaxY(),
        // label: null, //去掉Y轴
      },
      xAxis: {
        // 增加竖着的虚线
        grid: {
          line: {
            style: {
              stroke: '#E8E8E8',
              lineWidth: 2,
              lineDash: [4, 5],
              strokeOpacity: 0.7,
            },
          },
        },
        tickLine: null,
        line: {
          style: {
            stroke: '#fff',
          },
        },
      },
    });

    columnPlot.render();
  },
};
</script>
<style scoped lang="scss">
.columnBox {
  width: 678px;
  background: #fff;
  box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0 auto;
  padding: 36px 20px 36px 15px;
  .study-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 36px;
    padding-left: 18px;
    img {
      width: 29px;
      height: 29px;
    }
    span {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      padding-left: 5px;
    }
  }
  .columnTitle {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
    margin-bottom: 22px;
    span {
      display: block;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 6px;
      background: linear-gradient(180deg, #ffa376 0%, #ff7634 100%);
    }
  }
}
</style>
